import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "edit-container",
  style: {"padding":"16px","height":"100%","display":"flex","flex-direction":"column","justify-content":"space-between","box-sizing":"border-box"}
}
const _hoisted_2 = {
  class: "cm-align-center",
  style: {"flex":"1"}
}
const _hoisted_3 = {
  class: "cm-align-center",
  style: {"flex":"1"}
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("template", null, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "iconfont cm-icon-info",
    style: {"color":"var(--cm-color-text-regular)","font-weight":"normal","font-size":"18px"}
  })
], -1)
const _hoisted_5 = { class: "cm-align-center" }

import { getSvgIconDataUrl } from '@/utils/svg-icon-data-url'

import { ElLoading } from 'element-plus'
import { useI18n } from 'vue-i18n'
import { formLabelStyle } from '@/components/cmForm/globalOpt'
import CmForm from '@/components/cmForm/index.vue'
import { FormActionType, FormSize, FormType } from '@/components/cmForm/types'
import { PermissionFe } from '@/services/service-permission.service'
import { formatMapToOptions } from '@/utils/tool'
import PolicyBindScope from '@/views/dashboard/policy/_components/policy-bind-scope.vue'
import { policyBindScopeFormRules } from '@/views/dashboard/policy/_components/policy-bind-scope-form-rule'
import { PolicySettingType, PolicyType, } from '@/views/dashboard/_enum/policy-type'
import { SaveSettingsReq, SettingsResCommon, } from '@/views/dashboard/policy/policy-common.service'
import { ElMessage } from 'element-plus'
import { computed, nextTick, PropType, reactive, ref, watch } from 'vue'
import { approvalType, behaviorStateI18nKey, FormData, FormDataProps } from '../types/approval-terminal-file-outsourcing'
import { channelTypeI18nKey, DataTypeSensitive, DataTypeSensitiveText, SensitiveStateType, } from '../types/sensitive-file-scanning'
import { useRoute } from 'vue-router'
import ScanningConfig from './scanning-config.vue'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { ServicePermissionService } from '@/services/service-permission.service'


export default /*#__PURE__*/_defineComponent({
  __name: 'strategy-setting',
  props: {
  api: {
    type: Object as PropType<{
      saveOrUpdateApi: (data: SaveSettingsReq) => Promise<void>;
      getApi: ({ id, type }: { id: string; type: PolicySettingType }) => Promise<void>;
      listApi: () => []
      sensitiveWordsChannelApi: () => []
    }>,
    required: true,
  },
  id: {
    type: String,
    required: true,
  },
  modelValue: {
    type: Boolean,
    default: false,
  },
  fromGroupId: {
    type: Number,
  },
},
  emits: ['update:modelValue', 'refresh'],
  setup(__props, { emit: __emit }) {

const props = __props

// 注入权限服务
const injector = useReflectiveInjector([])
const servicePermissionService = injector.get(ServicePermissionService)
const hasPermission = servicePermissionService.getHasPermission(PermissionFe.dlp_control)

// 敏感词配置弹窗
const visibleScanningConfig = ref(false)

// 表单的禁用/启用
const disabled = ref(false)
// 通过 & 敏感词列表
const dataSensitiveWordsChannelList = reactive({
  list: [],
  sensitiveWordsChannel: []
})
// 表单实例对象
const formRef = ref()
const globalOpt = ref({ required: true })
// 表单的提交loading
const loading = ref(false)
const loadingPage = ref(false)
const strategyOver = ref({ type: PolicyType.dlp_control_type, current: '' })
// 表单数据
const form = ref<Partial<FormData>>({
  behavior: 1,
  name: '',
  group_ids: [],
  bind_mode: 0,
  device_ids: [],
  main_switch: 1,
  keyword_actions: [{ keyword: [], action: 0 }],
  send_channels_copy: [],
})
const { t, locale } = useI18n()
// 通道校验
const validate_send_channels = (rule, value, callback) => {
  if (!value.map(item => item.pipe).flat(1).length) {
    callback(new Error(t('sensitiveFileScanning.channelRequired')))
  }
  callback()
}
function buildBehaviorParseLabel() {
  const arr: any[] = formatMapToOptions(
    {
      1: t(behaviorStateI18nKey[1]),
      2: t(behaviorStateI18nKey[2]),
    },
    true
  )
  arr[0].subTitle = t('sensitiveFileScanning.targetFileOption1')
  arr[1].subTitle = t('sensitiveFileScanning.targetFileOption2')
  return arr
}
const parseLabel = ref(buildBehaviorParseLabel())
// 表单项配置
const formColumns = reactive({
  behavior: {
    label: t('sensitiveFileScanning.targetFileLabel'), type: FormType.RadioCm, radioGroupOpt:{ class:'gap-x-15' }, dictData: parseLabel.value, colOpt: { span: 24 }, events: {
      change: () => {
        formColumns.keyword_actions.required = formColumns.keyword_actions.columns.keyword.required = form.value.behavior === 1
      }
    }
  },
  name: {
    label: t('sensitiveFileScanning.strategyName'), inputOpt: { maxlength: 10, style: 'width: 500px' },
  },
  keyword_actions: {
    label: t('sensitiveFileScanning.controlMethod'), required: true, hidden: () => form.value.behavior === 2, type: FormType.DynamicTable, colOpt: { span: 23 }, plusText: t('sensitiveFileScanning.addDetection'), removeText: t('sensitiveFileScanning.remove'),
    tableOpt: {
      'max-height': '300px',
      bodyStyle: 'line-height: normal;padding: 6px',
    }, leastCount: 1, removeOpt: { type: 'danger', underline: false }, plusOpt: { style: 'margin-top:10px', type: 'primary', plain: true }, rowAdd: (done) => done({ keyword: [], action: 0 }), rowDel: (_row, done) => done(),
    columns: {
      keyword: {
        required: true, type: FormType.Cascader, cascaderOpt: { filterable: true, 'show-all-levels': false, }, props: { multiple: true, }, dictData: [], label: t('sensitiveFileScanning.fileSensitiveWord'), hiddenAllLabel: true,
        events: (index) => ({
          'visible-change': (visible: boolean) => {
            filterDisabled(index)
            // 当下拉框打开且数据为空时，动态替换空文本
            if (visible) {
              // 使用 setTimeout 确保下拉框已完全渲染
              setTimeout(() => {
                const emptyTextElements = document.querySelectorAll('.el-cascader-menu__empty-text')
                emptyTextElements.forEach((el: any) => {
                  if (el && (el.textContent === '暂无数据' || el.textContent.trim() === '' || el.textContent.includes('暂无'))) {
                    // 检查是否已经替换过，避免重复替换
                    if (!el.dataset.customEmpty) {
                      el.dataset.customEmpty = 'true'
                      // 创建自定义空文本内容
                      const emptyContent = document.createElement('div')
                      emptyContent.style.cssText = 'padding: 10px; text-align: center; white-space:nowrap;'
                      emptyContent.innerHTML = '<button class="el-button--text add-keyword-button" style="cursor:pointer;">' + t('sensitiveFileScanning.addKeywordButton') + '</button>'

                      // 添加点击事件
                      const btn = emptyContent.querySelector('.add-keyword-button')
                      if (btn) {
                        btn.addEventListener('click', (e) => {
                          e.stopPropagation()
                          // 打开敏感词配置弹窗
                          visibleScanningConfig.value = true
                        })
                      }

                      // 替换原内容
                      el.innerHTML = ''
                      el.appendChild(emptyContent)
                    }
                  }
                })
              }, 100)
            }
          },
          change: () => {
            filterDisabled(index)
          }
        })
      },
      action: {
        type: FormType.Radio, prop: 'action', width: 350, dictData: [{ label: t('sensitiveFileScanning.actionRecordOnly'), value: 0 }, { label: t('sensitiveFileScanning.actionApplyApproval'), value: 1 }, { label: t('sensitiveFileScanning.actionBlockOutbound'), value: 2 }], label: t('sensitiveFileScanning.executionAction'), hiddenAllLabel: true,
      },
    },
  },
  send_channels_copy: {
    labelSlot: true,
    label: t('sensitiveFileScanning.outboundMethod'), hiddenPlusBtn: true, hiddenDelBtn: true, required: true, tableOpt: { bodyStyle: 'line-height: normal;padding: 6px' }, type: FormType.DynamicTable, colOpt: { span: 23 }, rules: [{ custom: { validator: validate_send_channels } }],
    columns: [
      {
        prop: 'way', type: FormType.Text, label: t('sensitiveFileScanning.category'), hiddenAllLabel: true, width: 300
      },
      {
        props: { label: 'name', value: 'value' }, prop: 'pipe', type: FormType.CheckboxGroupCm, label: t('sensitiveFileScanning.detailLabel'), checkboxGroupOpt: { style: 'line-height: normal;' },
        events: {
          change: () => {
            formRef.value?.ruleFormRef?.validateField?.('send_channels_copy')
          }
        },
        hiddenAllLabel: true,
      },
    ],
  },
  group_ids: {
    label: t('policyBindScope.applyMode'),
    prop: 'group_ids',
    required: false,
    formItemOpt: { required: false },
    rules: policyBindScopeFormRules(() => form.value, t),
    labelSlot: true,
    slot: true,
    colOpt: { span: 24 },
  },
})
watch(locale, () => {
  parseLabel.value = buildBehaviorParseLabel()
  formColumns.behavior.dictData = parseLabel.value
})
const send_channels = ref([])
const emits = __emit
const visible = computed({
  get: () => props.modelValue,
  set: (value) => {
    emits('update:modelValue', value)
  },
})
const cancel = () => {
  visible.value = false
  handleReset();
  window.location.search && (window.location.search = '')
}
const validateTree = () => {
  formRef.value?.ruleFormRef?.validateField?.('group_ids')
}
const route = useRoute()

// 表单重置
const handleReset = async () => {
  form.value = {
    behavior: 1,
    name: route.query.name as string,
    main_switch: 1,
    keyword_actions: [{ keyword: [], action: 0 }],
    group_ids: [],
    bind_mode: 0,
    device_ids: [],
  }
}
// 表单数据提交
const handleSubmit = async () => {
  const valid = await formRef.value.handleSubmit()
  if (!valid) return
  const bm = form.value.bind_mode ?? 0
  loading.value = disabled.value = true
  const formCopy = { ...form.value }
  formCopy.keyword_actions = formCopy.keyword_actions.map(item => ({ ...item, keyword: (item.keyword.some(item => Array.isArray(item)) ? item.keyword.reduce((p, i) => (p.push(i[1]), p), []) : item.keyword) }))
  const strategy = {
    behavior: form.value.behavior,
    main_switch: form.value.main_switch,
    keyword_actions: form.value.behavior === 1 ? formCopy.keyword_actions : [],
    send_channels: form.value.send_channels_copy.map((item) => item.pipe).flat(1),
    font_keyword_actions: form.value.behavior === 1 ? form.value.keyword_actions : []
  }
  const formData: SaveSettingsReq = {
    name: form.value.name,
    group_ids: (form.value.group_ids || []) as number[],
    device_ids: form.value.device_ids || [],
    bind_mode: bm,
    id: form.value.id,
    type: PolicySettingType.dlp_control_type_setting_type,
    strategy_type: PolicyType.dlp_control_type,
    strategy: JSON.stringify(strategy),
  }
  console.log('formData :>> ', formData);
  const result: any = await props.api.saveOrUpdateApi(formData).finally(() => loading.value = disabled.value = false)
  const ok = result?.resp_common?.msg === 'ok'
  ElMessage({
    type: ok ? 'success' : 'error',
    message: ok ? t('sensitiveFileScanning.operationSuccess') : t('sensitiveFileScanning.operationFailed'),
  })
  if (ok) {
    emits('refresh')
    visible.value = false
    form.value.id = undefined
  }
}
// 过滤已选敏感词的禁用状态
const filterDisabled = (index) => {
  let list = []
  form.value.keyword_actions.forEach(item => {
    item.keyword.length && list.push(...item.keyword.map(([label, value]) => value))
  })
  formColumns.keyword_actions.columns.keyword.dictData.forEach(item => {
    item.children.forEach(cItem => {
      cItem.disabled = (list.some(item => item === cItem.value) && !form.value.keyword_actions[index].keyword.map(([label, value]) => value).includes(cItem.value))
    })
  })
}
// 构造数据结构
const changeKeywordActionsData = () => {
  formColumns.keyword_actions.columns.keyword.dictData = dataSensitiveWordsChannelList.list.filter(item => item.state === SensitiveStateType.Allowed).map(
    (item) => ({
      disabled: false,
      label: item.data_type === DataTypeSensitive.Customize ? item.name : t(DataTypeSensitiveText[item.data_type]),
      value: item.data_type === DataTypeSensitive.Customize ? item.name : t(DataTypeSensitiveText[item.data_type]),
      children: item.keywords.map((item) => ({ label: item, value: item, disabled: false })),
    }),
  )
}
const changeSendChannelsData = (checkAll = true) => {
  send_channels.value = dataSensitiveWordsChannelList.sensitiveWordsChannel
  form.value.send_channels_copy = dataSensitiveWordsChannelList.sensitiveWordsChannel.map((item) => ({
    way: t(channelTypeI18nKey[item.type as keyof typeof channelTypeI18nKey]),
    dictData: item.data.map(item => ({ ...item, svgOpt: { width: 20, height: 20, src: approvalType.includes(item.value) ? require(`@/views/dashboard/data-safe/anti-external-control/assets/approvalType/${item.value}.svg`) : '' } })),
    pipe: checkAll ? item.data.map((item) => item.value) : [],
  }))
  console.log('form.value.send_channels_copy :>> ', form.value.send_channels_copy);
}
// 获取通道和敏感词数据
const getList = async () => {
  const result: any = await props.api.listApi()
  const data: any = await props.api.sensitiveWordsChannelApi()
  dataSensitiveWordsChannelList.list = result.data
  dataSensitiveWordsChannelList.sensitiveWordsChannel = data.data
  changeKeywordActionsData()
}
// 移除 route.query.name 的 watch，因为 visible 状态由父组件通过 v-model 控制
// watch(() => route.query.name, (nv: string, ov) => {
//   visible.value = !!nv
// }, {
//   immediate: true,
// })
watch(
  () => props.modelValue,
  async (nv, ov) => {
    handleReset()
    loadingPage.value = true
    nv && await getList()
    if (nv && props.id) {
      const loadingFullScreen = ElLoading.service({
        target: document.getElementById('edit-container'),
        lock: true,
        text: t('sensitiveFileScanning.loading'),
      })
      strategyOver.value.current = props.id
      changeSendChannelsData(false)
      const result: Partial<SettingsResCommon> = await props.api.getApi({
        id: props.id,
        type: PolicySettingType.dlp_control_type_setting_type,
      })
      form.value = {
        ...form.value,
        ...result,
        ...result.strategy,
        keyword_actions: result.strategy.font_keyword_actions || result.strategy.keyword_actions,
        id: props.id,
      }
      formColumns.keyword_actions.required = formColumns.keyword_actions.columns.keyword.required = form.value.behavior === 1
      form.value.group_ids = result.strategy_group_ids
      form.value.bind_mode = result.bind_mode ?? 0
      form.value.device_ids = result.device_ids ?? []
      let list = [... new Set(result.strategy.send_channels)]
      list.forEach((value: string) => {
        for (let item of send_channels.value) {
          if (item.data.map((item) => item.value).includes(value)) {
            form.value.send_channels_copy.forEach((child) => {
              child.way === t(channelTypeI18nKey[item.type as keyof typeof channelTypeI18nKey]) && (!child.pipe.includes(value)) && child.pipe.push(value)
            })
          }
        }
      })
      console.log('form.value :>> ', form.value)
      loadingFullScreen.close()
    } else if (nv && !props.id) {
      changeSendChannelsData(true)
    }
    loadingPage.value = false
  },
  {
    immediate: true,
  },
)

return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_loading = _resolveDirective("loading")!

  return (visible.value)
    ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(CmForm, {
          formSize: _unref(FormSize).Small,
          ref_key: "formRef",
          ref: formRef,
          style: {"flex":"1","overflow-y":"auto","overflow-x":"hidden"},
          modelValue: form.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form).value = $event)),
          formType: _unref(FormActionType).Other,
          "onUpdate:formType": _cache[4] || (_cache[4] = ($event: any) => ((_unref(FormActionType).Other) = $event)),
          disabled: disabled.value,
          "onUpdate:disabled": _cache[5] || (_cache[5] = ($event: any) => ((disabled).value = $event)),
          formColumns: formColumns,
          formOpt: { 'label-width': '130px', labelPosition: 'left' },
          opeRowOpt: { justify: 'start', style: { marginTop: '20px' } },
          onReset: _cache[6] || (_cache[6] = () => (visible.value = false)),
          rowOpt: { style: { display:'grid' }, class:'gap-20' },
          globalOpt: globalOpt.value
        }, {
          group_ids: _withCtx(() => [
            _createVNode(PolicyBindScope, {
              "bind-mode": form.value.bind_mode ?? 0,
              "group-ids": form.value.group_ids || [],
              "device-ids": form.value.device_ids || [],
              "preset-group-id": form.value.id ? undefined : __props.fromGroupId,
              "permission-key": _unref(PermissionFe).dlp_control,
              "strategy-over": strategyOver.value,
              disabled: disabled.value,
              "onUpdate:bindMode": _cache[0] || (_cache[0] = 
            (v) => {
              form.value.bind_mode = v
              nextTick(() => validateTree())
            }
          ),
              "onUpdate:groupIds": _cache[1] || (_cache[1] = ($event: any) => (form.value.group_ids = $event)),
              "onUpdate:deviceIds": _cache[2] || (_cache[2] = 
            (v) => {
              form.value.device_ids = v
              nextTick(() => validateTree())
            }
          ),
              onGroupUpdate: validateTree
            }, {
              "group-tip": _withCtx(() => [
                _createElementVNode("strong", null, _toDisplayString(_ctx.$t('sensitiveFileScanning.strategyApplyGroupTip')), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.$t('sensitiveFileScanning.strategyApplyGroupTipContent')), 1)
              ]),
              _: 1
            }, 8, ["bind-mode", "group-ids", "device-ids", "preset-group-id", "permission-key", "strategy-over", "disabled"])
          ]),
          "group_ids-label": _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", {
                style: _normalizeStyle(_unref(formLabelStyle))
              }, _toDisplayString(_ctx.$t('policyBindScope.applyMode')), 5)
            ])
          ]),
          "send_channels_copy-label": _withCtx(({ label }) => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", {
                style: _normalizeStyle(_unref(formLabelStyle))
              }, _toDisplayString(label), 5),
              _createVNode(_component_el_tooltip, {
                placement: "bottom-start",
                effect: "light",
                trigger: "hover",
                width: 400,
                offset: 0
              }, {
                content: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createElementVNode("strong", null, _toDisplayString(label) + _toDisplayString(_ctx.$t('sensitiveFileScanning.sendChannelTipSuffix')), 1),
                    _createElementVNode("p", null, _toDisplayString(_ctx.$t('sensitiveFileScanning.sendChannelTipContent1')), 1),
                    _createElementVNode("div", null, _toDisplayString(_ctx.$t('sensitiveFileScanning.sendChannelTipContent2')), 1)
                  ])
                ]),
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 2
              }, 1024)
            ])
          ]),
          _: 1
        }, 8, ["formSize", "modelValue", "formType", "disabled", "formColumns", "globalOpt"]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_button, {
            type: "primary",
            plain: "",
            onClick: cancel,
            size: "small"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('sensitiveFileScanning.cancel')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (handleSubmit())),
            loading: loading.value,
            size: "small"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
            ]),
            _: 1
          }, 8, ["loading"])
        ]),
        _createVNode(ScanningConfig, {
          modelValue: visibleScanningConfig.value,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((visibleScanningConfig).value = $event)),
          onRefresh: getList,
          hasPermission: _unref(hasPermission)
        }, null, 8, ["modelValue", "hasPermission"])
      ])), [
        [_directive_loading, loadingPage.value]
      ])
    : _createCommentVNode("", true)
}
}

})